module.exports = __webpack_public_path__ + "static/media/trigger1.0171024a.png";